// @ts-ignore
import React from "react"
import { VenueCategory } from "../../../../types/venue";
// @ts-ignore
import Styles from "./SelectedCategoriesTitle.module.sass"

type SelectedCategoriesTitlePropsType = {
  categories: VenueCategory[],
  selectedRootCategory: VenueCategory,
  onClick: (id: string) => void,
}

const SelectedCategoriesTitle: React.FC<SelectedCategoriesTitlePropsType> = (props) => {

  const { selectedRootCategory, categories, onClick } = props;

  const selectedCategories = categories.filter(category => category.selected)

  return <div className={Styles.title}>
    <span className={Styles.link} onClick={() => onClick(selectedRootCategory.id)}>{selectedRootCategory.name}</span>
    {(selectedCategories.length > 0) &&
      <span>
        <span className={Styles.separator}>{" > "}</span>
        <span className={Styles.categories}>{selectedCategories.map(category => category.name).join(", ")}</span>
      </span>
    }


  </div>
}

export default SelectedCategoriesTitle
